/* eslint-disable */
export default {
  recentActivities: 'Activités récentes',
  text: 'SMS',
  fax: 'Fax',
  voicemail: 'Messagerie vocale',
  call: 'Appel',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
